import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const EditTransportModal = ({ isOpen, onClose, editFormData, setEditFormData, fetchData, branch, branches, user }) => {
  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
  e.preventDefault();

  // === Validation: Sub Dept Code ===
  if (!editFormData.code || editFormData.code.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Validation Error",
      text: "Sub Department Code should not be empty.",
    });
    return;
  }

  // === Validation: Sub Dept Name ===
  if (!editFormData.name || editFormData.name.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Validation Error",
      text: "Sub Department Name should not be empty.",
    });
    return;
  }

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.put(
      `https://rfs2.infraconsoft.net.in/api/subDept_update/${editFormData.slNo}`,
      {
        name: editFormData.name,
        branch: editFormData.branches,
        code: editFormData.code,
        slNo: editFormData.slNo,
        user: user,
      }
    );

    if (response.data.success) {
      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Updated successfully.",
      });
      onClose();
      fetchData();
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "This Code already exists. Please try a different one.",
      });
    }
  } catch (error) {
    Swal.close(); // close loading if any error
    console.error("Error updating sub department:", error);

    if (error.response && error.response.status === 400) {
      Swal.fire({
        icon: "error",
        title: "Duplicate Code",
        text: error.response.data.message || "This code already exists.",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Update failed. Please try again.",
      });
    }
  }
};


  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}   >
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
    <button className="close-btn" onClick={onClose}>
      &times;
    </button>
  </div>

        <h3>Edit Sub Department</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>

        <div className="form-row">
              <div className="form-group">
                <label>Branch :</label>
                <select
  name="branches"
  value={editFormData.branches}
  onChange={handleEditChange}
>
  <option value="">Select Branch</option>
  {branches.map((item) => (
    <option key={item.branchMaster_code} value={item.branchMaster_code}>
      {item.branchMaster_name}
    </option>
  ))}
</select>

              </div>
        </div>

          <div className="form-row">
              <div className="form-group">
                <label>Sub Department Code :</label>
                <input type="text" name="code" value={editFormData.code} onChange={handleEditChange} />
              </div>
        </div>

            <div className="form-row">
            <div className="form-group">
                <label>Sub Department Name :</label>
                <input
            type="text"
            name="name"
            value={editFormData.name}
            onChange={handleEditChange}
          />
              </div>
              
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Update
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default EditTransportModal;
